import React from 'react';
import { StyledConnector } from './styles';

const Connector = () => (
  <div style={{ flex: '1 1 auto' }}>
    <StyledConnector />
  </div>
);

export default Connector;
